module.exports = __webpack_public_path__ + "72a5380b6bd1516dd3d0151bd277b6c8.png";